(() => {
  const phone = '923152238323';
  const style = document.createElement('style');
  style.textContent = `
    .horus-whatsapp-button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      min-height: 48px;
      margin-top: 8px;
      padding: 12px 16px;
      box-sizing: border-box;
      border: 1px solid currentColor;
      border-radius: 6px;
      text-decoration: none;
      font-weight: 600;
      line-height: 1.2;
      text-align: center;
      cursor: pointer;
    }
    @media screen and (max-width: 749px) {
      .horus-whatsapp-button {
        min-height: 50px;
        margin-top: 10px;
        padding: 13px 14px;
        font-size: 15px;
      }
    }
  `;
  document.head.appendChild(style);

  function addWhatsAppButtons() {
    document.querySelectorAll('.product-form-buttons').forEach((container) => {
      const parent = container.parentElement;
      if (!parent || parent.querySelector('.horus-whatsapp-button')) return;

      const productForm = container.closest('product-form-component');
      const productUrl = productForm?.getAttribute('data-product-url') || window.location.pathname;
      const card = container.closest('product-card');
      const title = card?.querySelector('.product-card__link .visually-hidden')?.textContent?.trim()
        || document.querySelector('main h1')?.textContent?.trim()
        || document.title.split('|')[0].trim();

      const message = `Hi HORUS, I am interested in: ${title}\n${window.location.origin}${productUrl}`;
      const link = document.createElement('a');
      link.className = 'horus-whatsapp-button';
      link.href = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.setAttribute('aria-label', `WhatsApp HORUS about ${title}`);
      link.textContent = '💬 WhatsApp Us / WhatsApp Par Rabta Karein';
      container.insertAdjacentElement('afterend', link);
    });
  }

  addWhatsAppButtons();
  new MutationObserver(addWhatsAppButtons).observe(document.body, { childList: true, subtree: true });
})();